import { CapacitorUpdater } from 'Capacitor/@capgo/capacitor-updater'
import { boot } from 'quasar/wrappers'

export default boot(() => {
  CapacitorUpdater.notifyAppReady()
})
